var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "date-filter text-center" },
    [
      _c(
        "v-menu",
        {
          ref: "menu",
          attrs: {
            "close-on-content-click": false,
            transition: "scale-transition",
            "offset-y": "",
            "min-width": "290px",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-icon",
                    _vm._b(
                      {
                        staticClass:
                          "date-filter__menu-icon date-filter__menu-icon--down",
                        attrs: { light: "" },
                      },
                      "v-icon",
                      attrs,
                      false
                    ),
                    [_vm._v("\n        mdi-menu-down\n      ")]
                  ),
                  _c(
                    "v-icon",
                    _vm._b(
                      {
                        staticClass:
                          "date-filter__menu-icon date-filter__menu-icon--up",
                        attrs: { light: "" },
                      },
                      "v-icon",
                      attrs,
                      false
                    ),
                    [_vm._v("\n        mdi-menu-up\n      ")]
                  ),
                  _c(
                    "v-text-field",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            label: _vm.label,
                            clearable: "",
                            "prepend-inner-icon": "mdi-calendar-month",
                            "append-inner-icon": "mdi-calendar-month",
                            outlined: "",
                            dense: "",
                            readonly: "",
                            light: "",
                          },
                          on: {
                            "click:clear": function ($event) {
                              return _vm.clearDates()
                            },
                          },
                          model: {
                            value: _vm.dateRangeText,
                            callback: function ($$v) {
                              _vm.dateRangeText = $$v
                            },
                            expression: "dateRangeText",
                          },
                        },
                        "v-text-field",
                        attrs,
                        false
                      ),
                      on
                    )
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c("v-date-picker", {
            attrs: { range: "" },
            model: {
              value: _vm.dates,
              callback: function ($$v) {
                _vm.dates = $$v
              },
              expression: "dates",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }